<template>
    <div>
        <drag-zone class="zone">
            <drag-content class="content c1">
                <div class="item left-panel">
                    <slot name="left" :props="props"></slot>
                </div>
            </drag-content>
            <drag-handle class="handle noselect"></drag-handle>
            <drag-content class="content c2">
                <div class="item right-panel lp-viewport default-style">
                    <editor-text-styles></editor-text-styles>

                    <slot name="right" :props="props"></slot>
                </div>
            </drag-content>
        </drag-zone>
    </div>
</template>

<style>
    /* Sticky toolbar */
    .left-panel {
        overflow-y: auto !important;
    }

    .fr-box {
        overflow-y: scroll;
        max-height: calc(100vh - 120px);
    }

    .fr-fullscreen-wrapper .fr-box {
        overflow-y: scroll;
        max-height: 100vh;
    }

    .fr-toolbar.fr-top {
        position: -webkit-sticky; /* Safari */  
        position: sticky;
    }
</style>
<style scoped>
    .c1 {
        min-width: 450px;
        width: calc((100% - 500px - 10px));
    }
    .c2 {
        width: 500px;
        min-width: 450px;
    }

    .zone {
        width: 100%;
        height: 100vh;
        margin: 0 auto;
        position: relative;
        clear: both;
        text-align: center;
        background: #eee;
        display: flex;
        justify-content: space-between;
    }
    .left-panel {
        height: 100vh;
        overflow-y: scroll;
        text-align: left;
        background: white;
        color: black;
    }
    .right-panel {
        height: 100vh;
        overflow-y: scroll;
        text-align: left;
        background: white;
    }
    .zone .handle {
        width: 10px;
        height: 100vh;
        background: #2196f3;
    }
    .zone .content {
        height: 100%;
        overflow: hidden;
    }
    .zone .item {
        width: 100%;
    }
    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }
</style>
<script>
    export default {
        data() {
            let description = $('.initialDescription').html();
            let job = window.job;
            let url_base = window.url_base;

            return {
                'props': {
                    description: description,
                    job: job,
                    url_base: url_base
                },
            };
        },
        created() {
            window.addEventListener('resize', t => {
                let c1Width = $('.c1').width();
                let c2Width = $('.c2').width();
                let windowWidth = $(window).width();
            });
        }
    }
</script>
